import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


function TwoColumnRows(props) {
    return (
        <Row>
            {Array.from({length: props.children.length}, (_, index) => (
                <>
                    <Col sm={3} style={{"minWidth":"200px"}}>
                        {props.children[index * 4]}
                    </Col>
                    <Col sm={3} style={{"minWidth":"200px"}}>
                        {props.children[index * 4 + 1]}
                    </Col>
                    <Col sm={3} style={{"minWidth":"200px"}}>
                        {props.children[index * 4 + 2]}
                    </Col>
                    <Col sm={3} style={{"minWidth":"200px"}}>
                        {props.children[index * 4 + 3]}
                    </Col>
                </>
            ))}
        </Row>
    )
}

export default TwoColumnRows
